// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Tfay","newExpiryDate":"styles_newExpiryDate__VqHi2","footer":"styles_footer__k0AqP"};